import React from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import { VendorCard } from './VendorCard';
import { spacing } from '../../theme';
import { useColors, ThemeColors } from '../../hooks/useColors';
import type { Vendor } from '../../types/supabase';

interface VendorListProps {
  vendors: Vendor[];
}

export function VendorList({ vendors }: VendorListProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  const renderVendorCard = ({ item: vendor }) => (
    <VendorCard vendor={vendor} />
  );

  return (
    <FlatList
      data={vendors}
      renderItem={renderVendorCard}
      keyExtractor={item => item.id}
      contentContainerStyle={styles.container}
      ItemSeparatorComponent={() => <View style={styles.separator} />}
    />
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    padding: spacing.lg,
  },
  separator: {
    height: spacing.md,
  },
}); 